import { AbsoluteFill, Sequence } from "remotion";
import { SCENE, COLORS } from "./constants";
import { Scene01Title } from "./Scene01Title";
import { Scene02Multi } from "./Scene02Multi";
import { Scene03Security } from "./Scene03Security";
import { Scene04Nudge } from "./Scene04Nudge";
import { Scene05Intent } from "./Scene05Intent";
import { Scene06Learn } from "./Scene06Learn";
import { Scene07Host } from "./Scene07Host";
import { Scene08Outro } from "./Scene08Outro";

export const EAKCProductDemo: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: COLORS.bg }}>
      <Sequence from={SCENE.title.start}       durationInFrames={SCENE.title.duration}><Scene01Title /></Sequence>
      <Sequence from={SCENE.demo1Multi.start}  durationInFrames={SCENE.demo1Multi.duration}><Scene02Multi /></Sequence>
      <Sequence from={SCENE.demo2Sec.start}    durationInFrames={SCENE.demo2Sec.duration}><Scene03Security /></Sequence>
      <Sequence from={SCENE.demo3Nudge.start}  durationInFrames={SCENE.demo3Nudge.duration}><Scene04Nudge /></Sequence>
      <Sequence from={SCENE.demo4Intent.start} durationInFrames={SCENE.demo4Intent.duration}><Scene05Intent /></Sequence>
      <Sequence from={SCENE.demo5Learn.start}  durationInFrames={SCENE.demo5Learn.duration}><Scene06Learn /></Sequence>
      <Sequence from={SCENE.demo6Host.start}   durationInFrames={SCENE.demo6Host.duration}><Scene07Host /></Sequence>
      <Sequence from={SCENE.outro.start}       durationInFrames={SCENE.outro.duration}><Scene08Outro /></Sequence>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
